import { getUserAllSchoolProperty } from "../utils/utils";
import { chatActions } from "./chatAi-slice";

const newSessionCall = async (botId) => {
    const res = await fetch(`${window.config.botApi}/bina/sessions`,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({botId: botId})
    })
    return await res.json()
}


const postMessageCall = async (id, msg, isStudent, gender, name, grade) => {
    let student = true
    let gen = "Male"
    if (isStudent === "No") {
        student = false
    }
    if (gender === 2) {
        gen = "Female"
    }
    const res = await fetch(`${window.config.botApi}/bina/sessions/${id}/message`,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ message: msg, isStudent: student, gender: gen, name: name, grade: grade })
    })
    return await res.json()
}

const getSessionCall = async (id) => {
    const res =  await fetch (`${window.config.botApi}/sessions/${id}`,{
            method: 'GET',
            credentials: 'include'
        })
    return await res.json()
}

const deleteSessionCall = async (id) => {
    return await fetch (`${window.config.botApi}/sessions/${id}`,{
        method: 'DELETE',
        credentials: 'include',
    })
}

const reportSessionCall = async (id, reason) => {
    const res = await fetch(`${window.config.botApi}/bina/sessions/${id}/report`,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({reason: reason})
    })
    return
}

const getBotIdForUser = (userDetails, lang) => {
    let botId =  window.config.binaIds.mamlachti //default binaId
    console.log("default: " + botId)
    if (lang === "ar") {
        console.log("arab: " + window.config.binaIds.arab)
        botId = window.config.binaIds.arab
    } else {
        let supervisionId = getUserAllSchoolProperty(userDetails,"supervisionId") || [1]
        switch (supervisionId[0]) {
            case 1: 
                botId = window.config.binaIds.mamlachti //Mamlachti
                console.log("mamlachti: " + botId)
                break;
            case 2:
                botId = window.config.binaIds.mamlachtiDati //Mamlachti Dati
                console.log("dati: " + botId)
                break;
            case 3:
                botId = window.config.binaIds.haredi //Haredi
                console.log("haredi: " + botId)
                break;
            default:
                console.log("supervision: Unknown")
                botId = window.config.binaIds.mamlachti
        }
        
    
    }
    console.log("returning: " + botId)

    return botId
}


export const newSession = (botId) => {
    return async (dispatch) => {
        const res = await newSessionCall(botId)
        const id = res["sessionId"]
        const session = await getSessionCall(id)
        dispatch(chatActions.sessionUpdated({id: id, transcript: session.messages}))
    }
}

let getGrade = (grade) => {
    switch (grade) {
        case 1:  return 'א';
        case 2:  return 'ב';
        case 3:  return 'ג';
        case 4:  return 'ד';
        case 5:  return 'ה';
        case 6:  return 'ו';
        case 7:  return 'ז';
        case 8:  return 'ח';
        case 9:  return 'ט';
        case 10:  return 'י';
        case 11:  return 'כ';
        case 12:  return 'ל';
        default: return 'ז';
    }
}
export const postMessage = (msg, alerts) => {
    return async (dispatch, getState) => {

        const state = getState()
        let sessionId = state.chat.id
        if (sessionId == null) {
            let lang = state.translate.lang
            const botId = getBotIdForUser(state.auth.userDetails,lang)
            const res = await newSessionCall(botId)
            const id = res["sessionId"]
            sessionId = id
            const session = await getSessionCall(id)
            dispatch(chatActions.sessionUpdated({id: id, transcript: session.messages}))
        }

        const currentState = state.chat
        const currentTranscript = currentState.transcript
        let newTranscript = [...currentTranscript,{sender: "USER", text: msg}]
        dispatch(chatActions.messagePosted({transcript: newTranscript}))
        const gender =  state.auth.userDetails.genderId
        const isStudent =  state.auth.user.isstudent
        let name =  state.auth.userDetails.firstName
        if (isStudent) {
            name = state.auth.user.given_name
        }
        const grade =  getGrade(state.auth.userDetails.grade)

        const res = await postMessageCall(sessionId, msg, isStudent, gender, name, grade)
        if (res.sender === "SYSTEM" && res.info != "ALERT") {
            if (res.info == "EXHAUSTED") {
                newTranscript = [...newTranscript, {sender: "MODEL", text: alerts.outOfResourceAlert}]
                dispatch(chatActions.responseReceived({transcript: newTranscript}))    
            } else {
                newTranscript = [...newTranscript, {sender: "MODEL", text: alerts.geminiAlert}]
                dispatch(chatActions.responseReceived({transcript: newTranscript}))    
            }
        } else if (res.sender === "SYSTEM" || res.info == "Function") {
            newTranscript = [...newTranscript, {sender: "MODEL", text: alerts.internalAlert}]
            dispatch(chatActions.responseReceived({transcript: newTranscript}))    
        } else {
            newTranscript = [...newTranscript, {sender: "MODEL", text: res.reply}]
            dispatch(chatActions.responseReceived({transcript: newTranscript}))    
        }
    }
}

export const deleteSession = () => {
    return async (dispatch, getState) => {
        const currentState = getState().chat
        await deleteSessionCall(currentState.id)
        dispatch(chatActions.sessionDeleted())
    }
}

export const stateMachineTrigerred = (next) => {
    
    return async (dispatch, getState) => {
        dispatch(chatActions.stateMachineTrigerred({next: next}))
    }
}

export const sessionReported = (reason) => {
    return async (dispatch, getState) => {
        const id = getState().chat.id
        reportSessionCall(id,reason)
        dispatch(chatActions.sessionCleared())
    }
}

export const restartSession = () => {
    return async (dispatch) => {
        dispatch(chatActions.sessionCleared())
    }
}